import { useHttpClient, type SuccessResponse } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { OutboundDeliveryResponse } from './common/outboundDeliveryResponse';

interface OutboundDeliveryQueryRequest {
  from: string;
  to: string;
}

export interface ListOutboundDeliveryResponse extends SuccessResponse {
  deliveries: OutboundDeliveryResponse[];
}

export function useListOutboundDeliveryQueryApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  async function execute(requestBody: OutboundDeliveryQueryRequest) {
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('delivery/outbound/query'), {
      method: 'POST',
      headers,
      body: JSON.stringify(requestBody),
    });

    const text = translations.value.outboundDelivery.actions.fetchMany;

    const response = await httpClient.action<ListOutboundDeliveryResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk: async (r) => {
        const data = (await r.json()) as { deliveries: OutboundDeliveryResponse[] };
        return {
          ok: true,
          deliveries: data.deliveries,
        };
      },
    });

    return response;
  }

  return {
    execute,
  };
}
